module.exports = __webpack_public_path__ + "static/media/phone_number_verification.6804289e.png";